import React from 'react';
import PatternManager from './PatternManager';
import { useAuth } from '../store/AuthContext';

const Home: React.FC = () => {
  const { signOut } = useAuth();

  return (
    <div className='flex flex-col items-center mt-2'>
      <div className='flex items-center justify-center w-full gap-2 relative'>
        <p className='text-xl px-1 py-2 border-b border-solid border-black'>Pattern Manager</p>
        <p className='absolute right-4 text-sm underline cursor-pointer' onClick={signOut}>Sign out</p>
      </div>
      <PatternManager />
    </div>
  );
};

export default Home;
